import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { Group, Layout } from "@/comn/components";
import { api } from "@/comn";

type Exrt = {
    ctraExrtEur: string;
    ctraExrtUsd: string;
    ctraExrtAed: string;
    ctraExrtGbp: string;
    ctraExrtCny: string;
};

export const TaneswPortalMainExchangeRates = () => {
    const [foundExrt, setExrt] = useState<Exrt | null>(null);
    const { t } = useTranslation();

    const getExrt = async () => {
        try {
            let base = process.env.REACT_APP_API_PTLE || "",
                path = "/api/v1/comn/comn/main/exrt";
            const response = await api.get(base + path);
            const data = response.data.exrtList.content;
            setExrt(data);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getExrt();
    }, []);

    const today = dayjs().format("DD/MM/YYYY");
    const list: { img: string; name: string; currency: string; key: keyof Exrt }[] = [
        {
            img: `${process.env.PUBLIC_URL}/imgs/flag-EUR.png`,
            name: "Euro",
            currency: "EUR",
            key: "ctraExrtEur",
        },
        {
            img: `${process.env.PUBLIC_URL}/imgs/flag-USD.png`,
            name: "United States dollar",
            currency: "USD",
            key: "ctraExrtUsd",
        },
        {
            img: `${process.env.PUBLIC_URL}/imgs/flag-AED.png`,
            name: "United Arab Emirates dirham",
            currency: "AED",
            key: "ctraExrtAed",
        },
        {
            img: `${process.env.PUBLIC_URL}/imgs/flag-GBP.png`,
            name: "Pound sterling",
            currency: "GBP",
            key: "ctraExrtGbp",
        },
        {
            img: `${process.env.PUBLIC_URL}/imgs/flag-CNY.png`,
            name: "Renminbi (Chinese) yuan",
            currency: "CNY",
            key: "ctraExrtCny",
        },
    ];

    return (
        <Group height="100%">
            <Group.Header>
                <h2>Exchange Rates</h2>
            </Group.Header>
            <Group.Body>
                <Group.Section>
                    <Layout direction="col" padding={6} gap={6}>
                        <ul className="flex flex-col divide-y border-y">
                            {list.map((item) => {
                                const { img, name, currency, key } = item;
                                return (
                                    <li key={`Exchange Rates:${name}`} className="flex items-center py-4">
                                        <img src={img} alt={name} title={name} width={24} height={18} />
                                        <div className="ml-2 flex-1">{name}</div>
                                        <div className="w-10 text-right text-sm">{currency}</div>
                                        <div className="w-16 text-right text-sm">{foundExrt?.[key]}</div>
                                    </li>
                                );
                            })}
                        </ul>
                        <div className="text-darkgray text-sm text-right">
                            {t("L_CTRA_EXRT_MDFY_DT")} {today}
                        </div>
                    </Layout>
                </Group.Section>
            </Group.Body>
        </Group>
    );
};
